import { render, staticRenderFns } from "./ResultadoBuscaFlagRetirado.vue?vue&type=template&id=535bca5a"
import script from "./ResultadoBuscaFlagRetirado.vue?vue&type=script&lang=js"
export * from "./ResultadoBuscaFlagRetirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports